import React, { useState } from "react";
import { CiPause1, CiPlay1 } from "react-icons/ci";
import { IoVolumeMediumOutline } from "react-icons/io5";
import { FaSpinner } from "react-icons/fa";
import config from "../../config";
import { useTranslation } from "react-i18next";

const VoiceCard = ({ data }) => {
  const { t } = useTranslation("result");

  const [isPlaying, setIsPlaying] = useState(false);
  const [audio, setAudio] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // useEffect(() => {
  //   const fetchTtsData = async () => {
  //     setIsLoading(true);
  //     // const ttsData = voiceSummaries.find((summary) => data?.name === data?.name);
  //     // const response = await fetch("http://localhost:4000/api/tts", {
  //     const response = await fetch(`${config.nodeDomain}/tts`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ text: data?.voice_summary }),
  //     });
  //     const blob = await response.blob();
  //     const audioUrl = URL.createObjectURL(blob);
  //     const audio = new Audio(audioUrl);
  //     setAudio(audio);
  //     if (audio) {
  //       setIsLoading(false);
  //     }
  //   };

  //   fetchTtsData();

  //   console.log(data);
  // }, [data]);

  const fetchTtsData = async () => {
    setIsLoading(true);
    // const ttsData = voiceSummaries.find((summary) => data?.name === data?.name);
    // const response = await fetch("http://localhost:4000/api/tts", {
    try {
      const response = await fetch(`${config.nodeDomain}/tts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ text: data?.voice_summary }),
      });
      const blob = await response.blob();
      const audioUrl = URL.createObjectURL(blob);
      const generatedAudio = new Audio(audioUrl);
      setAudio(generatedAudio);
      if (audio) {
        setIsLoading(false);
      }
      generatedAudio.play();
    } catch (error) {
      console.log(error, "tts error");
    } finally {
      setIsLoading(false);
    }
  };

  const playAudio = async () => {
    console.log(audio);
    if (!audio) {
      await fetchTtsData();
    }
    // audio?.play();
    setIsPlaying(!isPlaying);
  };

  const handlePlayPause = () => {
    if (!isPlaying) {
      if (!audio) {
        playAudio();
      } else {
        audio.play();
      }
    } else {
      audio.pause();
    }
    setIsPlaying(!isPlaying);
  };

  // if (isLoading) {
  //   <div className="absolute top-0 left-0 h-screen w-screen z-50 flex justify-center items-center">
  //     <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500">
  //       <FaSpinner />
  //     </div>
  //   </div>;
  // }

  return (
    <div className="flex justify-end px-[10rem] md-max:px-[1rem]">
      <div className="bg-card w-1/3 md-max:w-full text-card-foreground flex flex-col gap-6 rounded-2xl border shadow-sm bg-gradient-to-r from-blue-50 to-green-50 border-blue-200">
        <div className="p-4 z-40 relative">
          <div className="flex items-center justify-between sm-max:my-2">
            <div className="flex items-center space-x-3">
              <button
                onClick={handlePlayPause}
                size="sm"
                className="bg-primary text-primary-foreground cursor-pointer shadow-xs hover:bg-primary/90 inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive bg-blue-500 hover:bg-blue-600 text-white rounded-full w-10 h-10 p-0"
              >
                {isLoading ? (
                  <FaSpinner className="animate-spin" />
                ) : isPlaying ? (
                  <CiPause1 className="w-4 h-4" />
                ) : (
                  <CiPlay1 className="w-4 h-4 ml-0.5" />
                )}
              </button>
              <div>
                <p className="font-medium text-blue-700">{t("voiceSummary.title")}</p>
                <p className="text-sm text-blue-600">
                  {isPlaying ? t("voiceSummary.playing") : t("voiceSummary.description")}
                </p>
              </div>
            </div>
            <IoVolumeMediumOutline className="w-7 h-7 text-blue-500" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoiceCard;
